import React, { useEffect, useState, memo } from 'react';
import { Coleccion } from './Coleccion';
import { Producto } from './ProductoCard';
const origen: Producto[] = [{
  coleccion: 'Origen',
  nombre: 'Tierra',
  notas: 'Sándalo · Palo Santo',
  descripcion: '"Madera seca, serena. Huele a raíces antiguas, a ese momento exacto en que todo el ruido se detiene y solo existes tú."',
  tags: ['Denso', 'Cálido', 'Enraizante'],
  gramaje: '210g · Cera de soya',
  variantes: [{
    label: 'Abierta',
    precio: '$69.000',
    shopifyVariantId: 44232110506087,
    imagen: 'https://cdn.magicpatterns.com/uploads/n6YfL5ePXUcBPg8JmdTyEU/TIERRA_-_VASO.png'
  }, {
    label: 'Con tapa',
    precio: '$79.000',
    shopifyVariantId: 44232112308327,
    imagen: 'https://cdn.magicpatterns.com/uploads/kgQRSyX3UsQKsibrHrPmUW/TIERRA.png'
  }]
}, {
  coleccion: 'Origen',
  nombre: 'Aire',
  notas: 'Bergamota · Té verde',
  descripcion: '"Claridad verde, luz suave. Ligero como un pensamiento que llega cuando dejas de buscarlo. El aroma de la claridad."',
  tags: ['Fresco', 'Verde', 'Expansivo'],
  gramaje: '210g · Cera de soya',
  variantes: [{
    label: 'Abierta',
    precio: '$69.000',
    shopifyVariantId: 44232116043879,
    imagen: 'https://cdn.magicpatterns.com/uploads/aU4MJVADUod3CcaTD3b1VN/AIRE_-_VASO.png'
  }, {
    label: 'Con tapa',
    precio: '$79.000',
    shopifyVariantId: 44232118173799,
    imagen: 'https://cdn.magicpatterns.com/uploads/4vLhKPZA24AobtiY9dgiJv/AIRE.png'
  }]
}, {
  coleccion: 'Origen',
  nombre: 'Agua',
  notas: 'Acorde marino · Eucalipto suave',
  descripcion: '"Frescura aireada, respiro limpio. Fresco como empezar de nuevo. Ligero como soltar lo que ya no cargas."',
  tags: ['Marino', 'Fresco', 'Liberador'],
  gramaje: '210g · Cera de soya',
  variantes: [{
    label: 'Abierta',
    precio: '$69.000',
    shopifyVariantId: 44232121679975,
    imagen: 'https://cdn.magicpatterns.com/uploads/ukzBe1eg3LFADuWacGyHrQ/AGUA_-_VASO.png'
  }, {
    label: 'Con tapa',
    precio: '$79.000',
    shopifyVariantId: 44232122859623,
    imagen: 'https://cdn.magicpatterns.com/uploads/keYpvtxTEhGH9Tn3gAn5zK/AGUA.png'
  }]
}];
const memoria: Producto[] = [{
  coleccion: 'Memoria',
  nombre: 'Hogar',
  notas: 'Vainilla · Almendra',
  descripcion: '"Cremoso, abrigo elegante. Cálido como una voz que dice que ya llegaste, que aquí estás a salvo."',
  tags: ['Dulce', 'Cálido', 'Acogedor'],
  gramaje: '210g · Cera de soya',
  variantes: [{
    label: 'Abierta',
    precio: '$69.000',
    shopifyVariantId: 44232124629095,
    imagen: 'https://cdn.magicpatterns.com/uploads/w9W4eo3ZEBjUw7u3jA3T3N/HOGAR_-_VASO.png'
  }, {
    label: 'Con tapa',
    precio: '$79.000',
    shopifyVariantId: 44232125415527,
    imagen: 'https://cdn.magicpatterns.com/uploads/m4nz4t857bvSqNe23hokNs/HOGAR.png'
  }]
}, {
  coleccion: 'Memoria',
  nombre: 'Recuerdo',
  notas: 'Manzanilla · Algodón',
  descripcion: '"Limpio, tierno, suave. Como releer una carta antigua. No te pone triste — te completa."',
  tags: ['Tierno', 'Suave', 'Nostálgico'],
  gramaje: '210g · Cera de soya',
  variantes: [{
    label: 'Abierta',
    precio: '$69.000',
    shopifyVariantId: 44232126169191,
    imagen: 'https://cdn.magicpatterns.com/uploads/effjBygjMwyaUSzwSBfZhQ/RECUERDO_-_VASO.png'
  }, {
    label: 'Con tapa',
    precio: '$79.000',
    shopifyVariantId: 44232126922855,
    imagen: 'https://cdn.magicpatterns.com/uploads/pmPqErpfEVK2w5QVBkjjDv/RECUERDO.png'
  }]
}, {
  coleccion: 'Memoria',
  nombre: 'Latir',
  notas: 'Tulipán · Vainilla suave',
  descripcion: '"Floral leve, calidez sutil. Esta vela no te calma — te despierta. Te recuerda que estás aquí, que sientes."',
  tags: ['Floral', 'Sutil', 'Vivo'],
  gramaje: '210g · Cera de soya',
  variantes: [{
    label: 'Abierta',
    precio: '$69.000',
    shopifyVariantId: 44232127545447,
    imagen: 'https://cdn.magicpatterns.com/uploads/4zeH33145gnNukJRGbZB7B/LATIR_-_VASO.png'
  }, {
    label: 'Con tapa',
    precio: '$79.000',
    shopifyVariantId: 44232127873127,
    imagen: 'https://cdn.magicpatterns.com/uploads/fH7ZohJJAvCbwyWfUmvUwZ/LATIR.png'
  }]
}];
const pausa: Producto[] = [{
  coleccion: 'Pausa',
  nombre: 'Ritual',
  notas: 'Palo Santo · Lavanda',
  descripcion: '"Serenidad profunda, centro. Esta vela no decora — consagra. Convierte cualquier rincón en un espacio de intención."',
  tags: ['Ceremonial', 'Centrado', 'Sereno'],
  gramaje: '210g · Cera de soya',
  variantes: [{
    label: 'Abierta',
    precio: '$69.000',
    shopifyVariantId: 44232128430183,
    imagen: 'https://cdn.magicpatterns.com/uploads/vGSeoB2yjvdJ9KDP9rZwgr/RITUAL_-_VASO.png'
  }, {
    label: 'Con tapa',
    precio: '$79.000',
    shopifyVariantId: 44232128692327,
    imagen: 'https://cdn.magicpatterns.com/uploads/4V9wvHz91vkpVSqzXHigwH/RITUAL.png'
  }]
}, {
  coleccion: 'Pausa',
  nombre: 'Descanso',
  notas: 'Manzanilla · Lavanda',
  descripcion: '"Calma herbal, descanso. Envolvente como una cobija en noviembre bogotano. Permiso de descansar sin culpa."',
  tags: ['Herbal', 'Suave', 'Sedante'],
  gramaje: '210g · Cera de soya',
  variantes: [{
    label: 'Abierta',
    precio: '$69.000',
    shopifyVariantId: 44232129118311,
    imagen: 'https://cdn.magicpatterns.com/uploads/4vDNsXg9cyc47H7i1wxV8D/DESCANSO_-_VASO.png'
  }, {
    label: 'Con tapa',
    precio: '$79.000',
    shopifyVariantId: 44232129380455,
    imagen: 'https://cdn.magicpatterns.com/uploads/pJDeeQxvhkvxQFmLmwGzpZ/DESCANSO.png'
  }]
}, {
  coleccion: 'Pausa',
  nombre: 'Silencio',
  notas: 'Algodón · Té negro',
  descripcion: '"Quietud sobria, té suave. No es vacío — es espacio. Para cuando el mundo ha hablado demasiado."',
  tags: ['Sobrio', 'Puro', 'Quieto'],
  gramaje: '210g · Cera de soya',
  variantes: [{
    label: 'Abierta',
    precio: '$69.000',
    shopifyVariantId: 44232129773671,
    imagen: 'https://cdn.magicpatterns.com/uploads/uVc1Jy35kDzMqs86K4xGpM/SILENCIO_-_VASO.png'
  }, {
    label: 'Con tapa',
    precio: '$79.000',
    shopifyVariantId: 44232130134119,
    imagen: 'https://cdn.magicpatterns.com/uploads/cUHBqnbo1HaC4AtEKXvPHh/SILENCIO.png'
  }]
}];
type Tab = 'origen' | 'memoria' | 'pausa';
export function ColeccionesTabs() {
  const [active, setActive] = useState<Tab>('origen');
  useEffect(() => {
    const onTabRequest = (event: Event) => {
      const detail = (event as CustomEvent).detail as Tab;
      if (detail === 'origen' || detail === 'memoria' || detail === 'pausa') {
        setActive(detail);
      }
    };
    window.addEventListener('savia:tab', onTabRequest as EventListener);
    try {
      const pending = window.sessionStorage.getItem('savia:pendingTab') as Tab | null;
      if (pending === 'origen' || pending === 'memoria' || pending === 'pausa') {
        setActive(pending);
        window.sessionStorage.removeItem('savia:pendingTab');
      }
    } catch {
      // Ignore storage errors.
    }
    return () => window.removeEventListener('savia:tab', onTabRequest as EventListener);
  }, []);
  return <div id="colecciones" data-id="element-81">
      <div className="colecciones__tabs" data-id="element-82">
        <button type="button" className={`tab-btn ${active === 'origen' ? 'active' : ''}`} onClick={() => setActive('origen')} data-id="element-83">
          Origen
        </button>
        <button type="button" className={`tab-btn ${active === 'memoria' ? 'active' : ''}`} onClick={() => setActive('memoria')} data-id="element-84">
          Memoria
        </button>
        <button type="button" className={`tab-btn ${active === 'pausa' ? 'active' : ''}`} onClick={() => setActive('pausa')} data-id="element-85">
          Pausa
        </button>
      </div>

      <div className={`coleccion-panel ${active === 'origen' ? 'active' : ''}`} data-id="element-86">
        <Coleccion id="origen" variant="origen" numero="Colección 01" nombre="Origen" descripcion="Para iniciar. Vuelve a lo que siempre fuiste — a lo esencial, a lo que está debajo del ruido." productos={origen} testimonio={{
        quote: '"Tierra es la vela que siempre había buscado. La uso en mis clases de yoga y mis estudiantes siempre preguntan qué es ese aroma."',
        autor: '— Carolina V., Cali'
      }} data-id="element-87" />
      </div>

      <div className={`coleccion-panel ${active === 'memoria' ? 'active' : ''}`} data-id="element-88">
        <Coleccion id="memoria" variant="memoria" numero="Colección 02" nombre="Memoria" descripcion="Para abrigar. Lo que el tiempo no logró borrar — los mejores momentos no se guardan en fotos, se guardan en aromas." productos={memoria} testimonio={{
        quote: '"Le regalé Hogar a mi mamá. Me dijo que olía exactamente como cuando éramos chicos. No esperaba llorar abriendo un paquete."',
        autor: '— Sebastián M., Bogotá'
      }} data-id="element-89" />
      </div>

      <div className={`coleccion-panel ${active === 'pausa' ? 'active' : ''}`} data-id="element-90">
        <Coleccion id="pausa" variant="pausa" numero="Colección 03" nombre="Pausa" descripcion="Para bajar el ruido. El arte de no hacer nada — y que eso sea suficiente." productos={pausa} testimonio={{
        quote: '"Encendí Silencio un martes en la noche y por primera vez en meses sentí que mi apartamento era mío de nuevo."',
        autor: '— Valentina R., Medellín'
      }} data-id="element-91" />
      </div>
    </div>;
}